import { ReactNode } from "react";
import { useTranslation } from "next-i18next";
import Header from "./Header";
import Footer from "./Footer";
const Layout: React.FC<{ children: ReactNode }> = ({ children }) => {
  const { i18n } = useTranslation("common");
  return (
    <div
      dir={i18n.dir()}
      className={`${
        i18n.language === "en" ? "" : "!font-[MainFont] "
      } relative flex flex-col w-full overflow-x-hidden bg-primary`}
    >
      <div className="flex flex-col min-h-screen w-full overflow-x-hidden">
        <Header />
        <div className="flex justify-center flex-1 w-full overflow-x-hidden">
          <main className="flex-1 max-w-[170rem] w-full overflow-x-hidden">
            {children}
          </main>
        </div>
        <Footer />
      </div>
    </div>
  );
};
export default Layout;
